/**
 * Payment plan detail with info passed from the parent app
 */
Vue.component('pay-plan-details-nipsco', {
  template: `
  <div>
    <p v-if="selectedPlan === 'SD'"><span class="label">Selected Plan</span> Six Month Standard</p>
    <p v-if="selectedPlan === 'SE'"><span class="label">Selected Plan</span> Twelve Month Standard</p>
    <div class="md-flex">
      <div class="w-md-50 m-r-md-20">
        <p><span class="label">Account Number</span> {{ accountId }}</p>
      </div>
      <div class="w-md-50 m-r-md-20">
        <p><span class="label">Account Balance</span> {{ frequencyDetails.totalAgreementAmount }}</p>
      </div>
    </div>
    <div class="md-flex">
      <div class="w-md-50 m-r-md-20">
      <p><span class="label">Down Payment Amount</span> {{ initialPaymentAmount }}</p>
      </div>
      <div class="w-md-50 m-r-md-20">
        <p><span class="label">Down Payment Due By</span> {{ initialPaymentDueDate }}</p>
      </div>
    </div>
    <div class="md-flex">
      <div class="w-md-50 m-r-md-20">
      <p><span class="label">Payment Frequency</span> Monthly payment of {{ frequencyDetails.paymentAmount }}</p>
      </div>
      <div class="w-md-50 m-r-md-20">
        <p><span class="label">Next Scheduled Payment Date</span> {{ nextPaymentDate }}</p>
      </div>
    </div>
  </div>
  `,

  /**
   * Props array
   */
  props: ['accountId', 'initialPaymentAmount', 'initialPaymentDueDate', 'nextPaymentDate', 'frequencyDetails', 'selectedPlan'],

});



// WEBPACK FOOTER //
// ./src/assets/toolkit/scripts/portal/vue/components/payPlanDetailsNipsco.js